import '../css/distributors.scss';
import {render} from 'preact';
import {DistributorApp} from '@containers/Distributors';
import PageNavigation from '@components/common/PageNavigation';

document.addEventListener( 'DOMContentLoaded', () => {

    PageNavigation.initialize( '#header--main' );

    const groupedList = document.getElementById( 'distributor-search--container' );

    if ( groupedList ) {
        groupedList.innerHTML = '';
        render( <DistributorApp countryId={groupedList.dataset.countryId}/>, groupedList );
    }
} );
